import { Roles } from 'src/common/types'
import type { RouteRecordRaw } from 'vue-router'
import { useClientContextStore } from 'src/client/stores'
import { Notify } from 'quasar'

const routeRecord: RouteRecordRaw = {
  name: 'client.students',
  path: 'students',
  component: () => import('src/client/pages/student/ClientStudents.vue'),
  redirect: { name: 'client.students.list' },
  meta: {
    roles: [Roles.Client],
    supportedPlatforms: ['desktop', 'mobile', 'native'],
    excludeEnv: [],
  },
  children: [
    {
      name: 'client.students.list',
      path: '',
      component: () => import('src/client/pages/student/StudentList.vue'),
      meta: {
        roles: [Roles.Client],
        supportedPlatforms: ['desktop', 'mobile', 'native'],
        excludeEnv: [],
      },
    },
    {
      name: 'client.students.detail',
      path: ':id',
      component: () => import('src/client/pages/student/StudentDetail.vue'),
      meta: {
        roles: [Roles.Client],
        supportedPlatforms: ['desktop', 'mobile', 'native'],
        excludeEnv: [],
      },
    },
    {
      name: 'client.students.edit',
      path: ':id/edit',
      component: () => import('src/client/pages/student/StudentEditor.vue'),
      beforeEnter: (to, from, next) => {
        const studentId = to.params.id as string
        if (!studentId) {
          next({ name: 'client.students.list' })
          return
        }
        next()
      },
      meta: {
        roles: [Roles.Client],
        supportedPlatforms: ['desktop', 'mobile', 'native'],
        excludeEnv: [],
      },
    },
    {
      name: 'client.students.new',
      path: 'new',
      component: () => import('src/client/pages/student/StudentEditor.vue'),
      beforeEnter: (to, from, next) => {
        const contextStore = useClientContextStore()

        // Only primary members can create new students
        if (!contextStore.loggedInMember?.isPrimaryMember) {
          Notify.create({
            type: 'negative',
            message: 'Only primary members can add new children.',
            position: 'top',
          })
          next({ name: 'client.students.list' })
          return
        }

        next()
      },
      meta: {
        roles: [Roles.Client],
        supportedPlatforms: ['desktop', 'mobile', 'native'],
        excludeEnv: [],
      },
    },
  ],
}

export default routeRecord
